export default [
    () => {
        return {
            restrict: "EA",
            require: "^appPick",
            replace: true,
            scope: {
                title: "@",
                disabled: "="
            },
            template: `<div class="ws-pick-target">
            <div class="ws-pick-title">
                <p>{{title}}</p>    
                <a ng-if="!disabled" ng-click="deleteAll()">删除全部</a>
            </div>
            <div class="ws-pick-body">
              <div class="ws-pick-list">
                <ul>
                    <li ng-repeat="item in data">
                        <nk-checkbox class="nk-checkbox-success" ng-disabled="disabled" ng-model="param.choose" value="item.value">{{item.view}}</nk-checkbox>
                    </li>
                </ul>
              </div>
            </div>
        </div>`,
            link: ($scope, $element, $attr, ctrl) => {
                $element[0].removeAttribute("title");

                $scope.data = [];

                $scope.param = {};

                $scope.param.choose = [];

                $scope.hasSearchFn = !!$attr.search;

                let isClickDeleteAllBtn = false;

                $scope.deleteAll = () => {
                    isClickDeleteAllBtn = true;
                    $scope.param.choose = $scope.data.map((item) => item.value);
                };

                $scope.$watch(
                    "param.choose",
                    (newVal) => {
                        ctrl.setCheckTarget(newVal);
                        if (isClickDeleteAllBtn) {
                            ctrl.trigger("left");
                            isClickDeleteAllBtn = false;
                        }
                    },
                    true
                );

                ctrl.listenTargetChange((data) => {
                    $scope.$evalAsync(() => {
                        $scope.param.choose = [];
                        $scope.data = data;
                    });
                });
            }
        };
    }
];
